export default "__VITE_ASSET__3f301fb1__"